import { forwardRef, useLayoutEffect, useMemo, useRef } from 'react';
import { MeetingsFilter } from 'components/meetings';
import { AllSchedulingMethods, FilterTypes } from 'constants/meetings';
import { PageFilterRenderer } from 'features/app_shell/shell_layout/pageFilterContext';
import { useGetMeetingRecapsQuery } from './graphql_api';
import { createUseResultsCount } from './hooks/use_results_count';
import { DEFAULT_MEETINGS_RECAP_SCOPE, MEETINGS_RECAP_SCOPE, RecapScopeTabs } from './recap_scope_tabs';
import { SearchInput } from './search';
const headerContainerCss = "hkuxppa";
const recapScopeTabsWrapCss = "r1lcmzis";
const rowCss = "r1vdaxlj";
const filterSectionCss = "f1mqdnsv";
const filterProps = useResultsCount => ({
  location: 'recaps_page',
  hiddenFilters: [FilterTypes.BUFFER_VIEW, FilterTypes.STATUS, FilterTypes.ROLE, FilterTypes.TRACKING_SELECT, FilterTypes.NOTETAKER_RECAP],
  filterDefaults: {
    period: 'past',
    scheduling_methods: AllSchedulingMethods
  },
  useResultsCount
});
export const SearchAndFilter = forwardRef((props, ref) => {
  const {
    hideFilter,
    recapScope,
    setRecapScope,
    hasRecapSharingAccess
  } = props;
  const hasInitializedRecapScope = useRef(false);
  useLayoutEffect(() => {
    if (!hasRecapSharingAccess || hasInitializedRecapScope.current) return;
    hasInitializedRecapScope.current = true;
    setRecapScope(DEFAULT_MEETINGS_RECAP_SCOPE);
  }, [hasRecapSharingAccess, setRecapScope]);
  const useResultsCount = useMemo(() => createUseResultsCount(useGetMeetingRecapsQuery, hasRecapSharingAccess ? recapScope : MEETINGS_RECAP_SCOPE.ALL_RECAPS), [hasRecapSharingAccess, recapScope]);
  if (hideFilter) return null;
  return <PageFilterRenderer>
      <div ref={ref} className={headerContainerCss}>
        <div className={rowCss}>
          <div className={filterSectionCss}>
            <SearchInput />
            <MeetingsFilter {...filterProps(useResultsCount)} />
          </div>
        </div>
        {hasRecapSharingAccess && <div className={recapScopeTabsWrapCss}>
            <RecapScopeTabs value={recapScope} onChange={setRecapScope} />
          </div>}
      </div>
    </PageFilterRenderer>;
});

require("./search_and_filter.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_and_filter.js");